/**
 * LS USP glow — a soft orange light that follows the pointer behind the
 * value-prop cards.
 *
 * Markup: [data-ls-usp-glow] is the section's inner wrapper. This script only
 * writes --glow-x / --glow-y (pixels from the wrapper's top-left) and toggles
 * .is-glowing while the pointer is inside. The stylesheet draws the light and
 * the lift on the hovered card, so the look is tuned in CSS alone.
 *
 * Touch screens and reduced motion get the static glow from the stylesheet;
 * this script does nothing there.
 */
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

class LSUspGlow {
  constructor(root) {
    this.root = root;
    this.frame = 0;
    this.rect = null;
    if (reducedMotion.matches || !finePointer.matches) return;

    root.addEventListener('pointerenter', (event) => {
      this.rect = root.getBoundingClientRect();
      this.move(event);
      root.classList.add('is-glowing');
    });
    root.addEventListener('pointermove', (event) => this.move(event));
    root.addEventListener('pointerleave', () => {
      root.classList.remove('is-glowing');
      this.rect = null;
    });
  }

  move(event) {
    if (!this.rect) this.rect = this.root.getBoundingClientRect();
    const x = event.clientX - this.rect.left;
    const y = event.clientY - this.rect.top;
    cancelAnimationFrame(this.frame);
    this.frame = requestAnimationFrame(() => {
      this.root.style.setProperty('--glow-x', `${x}px`);
      this.root.style.setProperty('--glow-y', `${y}px`);
    });
  }
}

const initUspGlow = (scope = document) => {
  scope.querySelectorAll('[data-ls-usp-glow]').forEach((root) => {
    if (root.lsUspGlow) return;
    root.lsUspGlow = new LSUspGlow(root);
  });
};

initUspGlow();
document.addEventListener('shopify:section:load', (event) => initUspGlow(event.target));
